import type { InvoiceItem } from '../../store/usePEInvoiceStore';

/** Unverbindlichkeits-Klausel für Kostenvoranschläge */
export const ESTIMATE_PROGNOSIS_DISCLAIMER =
  'Dieser Kostenvoranschlag ist eine unverbindliche Prognose und kein fester Vertragspreis. Tatsächlicher Zeitaufwand und Materialverbrauch können die Kosten stark beeinflussen und vom ausgewiesenen Betrag abweichen.';

export function formatInvoiceItemServiceMeta(item: InvoiceItem): string {
  if (item.kind !== 'service') return '';
  const parts: string[] = ['Dienstleistung'];
  if (item.serviceHours > 0) {
    parts.push(`Zeitaufwand: ${item.serviceHours} Std.`);
  }
  if (item.hourlyRate > 0) {
    parts.push(
      `Stundensatz: ${item.hourlyRate.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
      })}`
    );
  }
  parts.push(
    item.materialMode === 'inclusive' ? 'Material: inklusiv' : 'Material: exklusiv'
  );
  return parts.join(' · ');
}
